/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AiTokenLimit} from '../models/AiTokenLimit';
import type {AiTokenLimits} from '../models/AiTokenLimits';
import type {AiTokenTemporaryLimit} from '../models/AiTokenTemporaryLimit';
import type {Error} from '../models/Error';
import type {UserAiTokenOverridesSaveRequest} from '../models/UserAiTokenOverridesSaveRequest';
import type {UserAiTokenTemporaryOverridesSaveRequest} from '../models/UserAiTokenTemporaryOverridesSaveRequest';

export interface GetUserAiTokenLimits$Request {
    userId: number;
}

export interface GetUserAiTokenLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserAiTokenLimitsRequest = createAction<PayloadData<void, GetUserAiTokenLimits$Request>>('USER_AI_TOKEN_LIMITS__GET_USER_AI_TOKEN_LIMITS__REQUEST');
export const getUserAiTokenLimitsSuccess = createAction<PayloadData<AiTokenLimits, GetUserAiTokenLimits$Request>>('USER_AI_TOKEN_LIMITS__GET_USER_AI_TOKEN_LIMITS__SUCCESS');
export const getUserAiTokenLimitsFailure = createAction<PayloadData<Error, GetUserAiTokenLimits$Request, true>>('USER_AI_TOKEN_LIMITS__GET_USER_AI_TOKEN_LIMITS__FAILURE');

export const getUserAiTokenLimitsActions = [
    getUserAiTokenLimitsRequest,
    getUserAiTokenLimitsSuccess,
    getUserAiTokenLimitsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserAiTokenLimits = (meta: GetUserAiTokenLimits$Request, config?: GetUserAiTokenLimits$Config) => {
    return {
        CALL_API: {
            types: getUserAiTokenLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/ai-token-limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveUserAiTokenOverrides$Request {
    userId: number;
    userAiTokenOverridesSaveRequest: UserAiTokenOverridesSaveRequest;
}

export interface SaveUserAiTokenOverrides$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveUserAiTokenOverridesRequest = createAction<PayloadData<void, SaveUserAiTokenOverrides$Request>>('USER_AI_TOKEN_LIMITS__SAVE_USER_AI_TOKEN_OVERRIDES__REQUEST');
export const saveUserAiTokenOverridesSuccess = createAction<PayloadData<Array<AiTokenLimit>, SaveUserAiTokenOverrides$Request>>('USER_AI_TOKEN_LIMITS__SAVE_USER_AI_TOKEN_OVERRIDES__SUCCESS');
export const saveUserAiTokenOverridesFailure = createAction<PayloadData<Error, SaveUserAiTokenOverrides$Request, true>>('USER_AI_TOKEN_LIMITS__SAVE_USER_AI_TOKEN_OVERRIDES__FAILURE');

export const saveUserAiTokenOverridesActions = [
    saveUserAiTokenOverridesRequest,
    saveUserAiTokenOverridesSuccess,
    saveUserAiTokenOverridesFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserAiTokenOverridesSaveRequest} meta.userAiTokenOverridesSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveUserAiTokenOverrides = (meta: SaveUserAiTokenOverrides$Request, config?: SaveUserAiTokenOverrides$Config) => {
    return {
        CALL_API: {
            types: saveUserAiTokenOverridesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/ai-token-limits/overrides`,
            TRANSPORT_REQUEST_BODY: meta.userAiTokenOverridesSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveUserAiTokenTemporaryOverrides$Request {
    userId: number;
    userAiTokenTemporaryOverridesSaveRequest: UserAiTokenTemporaryOverridesSaveRequest;
}

export interface SaveUserAiTokenTemporaryOverrides$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveUserAiTokenTemporaryOverridesRequest = createAction<PayloadData<void, SaveUserAiTokenTemporaryOverrides$Request>>('USER_AI_TOKEN_LIMITS__SAVE_USER_AI_TOKEN_TEMPORARY_OVERRIDES__REQUEST');
export const saveUserAiTokenTemporaryOverridesSuccess = createAction<PayloadData<Array<AiTokenTemporaryLimit>, SaveUserAiTokenTemporaryOverrides$Request>>('USER_AI_TOKEN_LIMITS__SAVE_USER_AI_TOKEN_TEMPORARY_OVERRIDES__SUCCESS');
export const saveUserAiTokenTemporaryOverridesFailure = createAction<PayloadData<Error, SaveUserAiTokenTemporaryOverrides$Request, true>>('USER_AI_TOKEN_LIMITS__SAVE_USER_AI_TOKEN_TEMPORARY_OVERRIDES__FAILURE');

export const saveUserAiTokenTemporaryOverridesActions = [
    saveUserAiTokenTemporaryOverridesRequest,
    saveUserAiTokenTemporaryOverridesSuccess,
    saveUserAiTokenTemporaryOverridesFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserAiTokenTemporaryOverridesSaveRequest} meta.userAiTokenTemporaryOverridesSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveUserAiTokenTemporaryOverrides = (meta: SaveUserAiTokenTemporaryOverrides$Request, config?: SaveUserAiTokenTemporaryOverrides$Config) => {
    return {
        CALL_API: {
            types: saveUserAiTokenTemporaryOverridesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/ai-token-limits/temporary-overrides`,
            TRANSPORT_REQUEST_BODY: meta.userAiTokenTemporaryOverridesSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

